import React from 'react';
import { Grid } from '@mui/material';

const FormGrid = props => {
  const { children } = props;
  return (
    <Grid container>
      <Grid item xs={12} sm={8} md={6}>
        {children}
      </Grid>
    </Grid>
  );
};

export default FormGrid;
